import React from 'react';
import { Loading } from '@op/opds.opux';

const LoadingIndicator = (props) => {
    return (
        <div className='loading-indicator'>
            <Loading />
        </div>
    );
};

export default LoadingIndicator;
